module.exports = __webpack_public_path__ + "img/icon-01.f8de1f6b.png";